__turbopack_context__.v({
  "AddressIconContainer": "footer-module-scss-module__j857JG__AddressIconContainer",
  "addressHeading": "footer-module-scss-module__j857JG__addressHeading",
  "addressSection": "footer-module-scss-module__j857JG__addressSection",
  "captchaNotice": "footer-module-scss-module__j857JG__captchaNotice",
  "footerBottom": "footer-module-scss-module__j857JG__footerBottom",
  "footerContainer": "footer-module-scss-module__j857JG__footerContainer",
  "footerCopyright": "footer-module-scss-module__j857JG__footerCopyright",
  "footerLinks": "footer-module-scss-module__j857JG__footerLinks",
  "footerLogo": "footer-module-scss-module__j857JG__footerLogo",
  "footerSection": "footer-module-scss-module__j857JG__footerSection",
  "footerSection--franchiseSection": "footer-module-scss-module__j857JG__footerSection--franchiseSection",
  "footerSections": "footer-module-scss-module__j857JG__footerSections",
  "footerTextSection": "footer-module-scss-module__j857JG__footerTextSection",
  "linksCopyrightWrapper": "footer-module-scss-module__j857JG__linksCopyrightWrapper",
  "listHeader": "footer-module-scss-module__j857JG__listHeader",
  "socialIcons": "footer-module-scss-module__j857JG__socialIcons",
  "visuallyHidden": "footer-module-scss-module__j857JG__visuallyHidden",
});
